import ViewConstructor from './../components/ViewConstructor';

/** 
  Class representing the Landing page
*/
class LandingPage extends ViewConstructor {

  /** 
  ## componentDidMount
  This is an override of the ViewContructor method.
  - fires consultationButton if it exists
  */
  componentDidMount() {
    this.$ref.find('.button-container').append(this.cloneConsultationButton());
  }

  componentDidEnter() {
    super.componentDidEnter();

    $(window).trigger('landing-page-enter');
  }

  loadSection(newRouteState, galleryConfig) {
    const that = this;
    
    let gallery = galleryConfig;

    that.updateMeta(gallery.state.practice.locality.city +', ' + gallery.state.practice.locality.state + ' Before-and-After photos', 'View the before-and-after photos of our patients in ' + gallery.state.practice.locality.city +', ' + gallery.state.practice.locality.state);
    that.updateCanoncial(window.location.origin + that.state.baseUrl);
  }

  /**
  Renders a generic template. 
  */
  render() {
    return `
      <div id="gallery-landing-content">
        <div class="gallery-home-top">
          <p class="gallery-mobile">Select a procedure to begin your search</p>
          <h2 class="gallery-desktop">Select a procedure to begin your search.</h2>
        </div>
        <div class="gallery-desktop next-step">
          <p>Ready for the next step? Contact us to request your consultation.</p>

          <div class="button-container"></div>
        </div>
      </div>
    `;
  }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/scripts/site/gallery-views/LandingPage.js